<template>
  <div>
    <el-upload
      :file-list="fileList"
      list-type="picture-card"
      :http-request="httpRequest"
      :before-upload="beforeUpload"
      multiple
      :disabled="disabled || limitDisabled"
      :limit="limit"
    >
      <div slot="trigger">
        <i v-if="fileList.length < limit" class="el-icon-plus"></i>
      </div>
      <div
        slot="file"
        slot-scope="{ file }"
        style="
          height: 100%;
          padding: 2px;
          display: flex;
          justify-content: space-around;
          align-items: center;
        "
      >
        <img
          v-if="
            file.originalName &&
            ['jpg', 'jpeg', 'png', 'gif'].includes(
              file.originalName.split('.').pop()
            )
          "
          style="max-height: 100%; max-width: 100%"
          :src="file.link"
        />
        <div
          v-else-if="
            file.originalName &&
            ['mp4', 'mpeg4', 'webm'].includes(
              file.originalName.split('.').pop()
            )
          "
        >
          <video
            ref="Audio"
            class="el-upload-list__item-thumbnail"
            :src="file.link"
          />
        </div>
        <div
          v-else-if="
            file.originalName &&
            ['mp3', 'ogg'].includes(file.originalName.split('.').pop())
          "
          style="max-height: 100%; max-width: 100%"
        >
          <div style="text-align: center; font-size: 12px">
            {{ file.originalName }}
          </div>
        </div>
        <div v-else style="padding: 5px; line-height: 20px">
          <span v-if="!file.link">上传中...</span>
          <div v-else style="font-size: 12px">
            <div style="color: red; text-align: center">
              {{ file.originalName }}
            </div>
            <div style="text-align: center">不支持预览</div>
          </div>
        </div>
        <span class="el-upload-list__item-actions">
          <span
            class="el-upload-list__item-preview"
            @click="handlePictureCardPreview(file)"
          >
            <i class="el-icon-zoom-in"></i>
          </span>
          <span
            class="el-upload-list__item-delete"
            @click="handleDownload(file)"
          >
            <i class="el-icon-download"></i>
          </span>
          <span
            v-if="!disabled"
            class="el-upload-list__item-delete"
            @click="handleRemove(file)"
          >
            <i class="el-icon-delete"></i>
          </span>
        </span>
      </div>
      <div slot="tip" class="el-upload__tip" v-if="!disabled">
        提示：上传文件不大于{{ max / (1024 * 1024) }}MB，上传数量
        {{ fileList.length }}/{{ limit }}
      </div>
    </el-upload>
    <el-dialog :visible.sync="maskShow" append-to-body width="90%">
      <div v-if="maskItem.originalName && maskShow" style="width: 100%">
        <img
          style="max-width: 100%"
          v-if="
            maskItem.originalName &&
            ['jpg', 'jpeg', 'png', 'gif'].includes(
              maskItem.originalName.split('.').pop()
            )
          "
          :src="maskItem.link"
        />
        <video
          style="max-width: 100%"
          v-else-if="
            maskItem.originalName &&
            ['mp4', 'mpeg4', 'ogg', 'mp3', 'webm'].includes(
              maskItem.originalName.split('.').pop()
            )
          "
          :src="maskItem.link"
          controls
        ></video>
        <div v-else style="padding: 20px">
          {{ maskItem.originalName }} <br />
          不支持预览
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { putFile, downloadFile } from "@/api/crmedical/contract/add";
import website from "@/config/website";
export default {
  props: {
    fileList: {
      type: Array,
      default: function () {
        return [];
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    max: {
      type: Number,
      default: 12 * 1024 * 1024,
    },
    limit: {
      type: Number,
      default: 3,
    },
    message:{
        type: String,
        default: '请上传正确格式文件',
    },
    types:{
      type:Array,
      default: function () {
        return [
          'audio/ac3',
          'allpication/vnd.ms-asf',
          'audio/basic',
          'text/css',
          'text/csv',
          'application/msword',
          'application/msword',
          'application/xml-dtd',
          'image/vnd.dwg',
          'image/vnd.dxf',
          'image/gif',//gif
          'text/html',
          'image/jp2',
          'image/jpeg',//
          'image/pjpeg',//jpg 火狐
          'image/x-png',//png
          'image/bmp',//bmp
          'application/zip',//zip
          'image/x-icon',//ico
          'application/octet-stream',//psd
          'text/javascript',
          'application/json',
          'audio/mpeg',
          'audio/mp4',
          'video/mp4',
          'audio/wav',
          'video/mpeg',
          'application/vnd.ms-project',
          'application/ogg',
          'application/pdf',
          'image/png',
          'application/vnd.ms-powerpoint',
          'application/rtf',
          'image/vnd.svf',
          'image/tiff',
          'text/plain',
          'application/vnd.ms-works',
          'application/xhtml+xml',
          'application/vnd.ms-excel',
          'text/xml',
          'application/xml',
          'text/rtf',
          'aplication/zip',
          'application/x-zip-compressed',

        ];
      },
    }
  },
  watch: {
    fileList() {
      let len = this.fileList.length;
      this.limitDisabled = len >= this.limit;
    },
  },
  data() {
    return {
      maskShow: false,
      maskItem: {},
      limitDisabled: false,
      mediaElement: null,
    };
  },
  methods: {
    handlePictureCardPreview(file) {
      console.log("213==>", 213);
      console.log("file==>", file);
      this.maskItem = file;
      this.maskShow = true;
    },
    //同步数据到父组件
    update() {
      // status:'success' 后端会报错
      this.fileList.forEach((item) => {
        item.status = 1;
      });
      let len = this.fileList.length;

      this.limitDisabled = len >= this.limit;
      console.log("this.limit==>", this.limit);
      console.log("this.limitDisabled==>", this.limitDisabled);
      console.log("this.fileList==>", this.fileList);
      
      this.$emit("update:fileList", this.fileList);
    },
    beforeUpload(file) {
      console.log("beforeUpload==>");
      if (this.limitDisabled) return;
      console.log("beforeUpload==>");
      this.max = this.max || website.maxUploadSize;
      if (file.size > this.max) {
        console.log("this.fileList==>", this.fileList);
        this.putFile = Object.assign({}, this.fileList);
        this.$message.error(`文件不能大于${this.max / (1024 * 1024)}MB`);
        return false;
      }
      // 判断上传文件格式
      let flag = false;
      console.log(file)
      let fileType = file.type;
      this.types.forEach(ele=>{
        console.log(ele)
        if(ele==fileType){
          flag = true;
        }
      })
      if(!flag){
        this.$message({
          showClose: true,
          message:this.message, 
          type: 'error'
        });
        return false;
      }
      
    },
    //上传方法
    httpRequest(file) {
      console.log(file)
      console.log("this.httpRequest.fileList= =>", this.fileList);
      let fd = new FormData();
      
      fd.append("file", file.file);
      putFile(fd)
        .then((res) => {
          console.log(res);
          res.data.uid = file.file.uid;
          if (res.success) {
            //处理一个bug
            if (!res.data["id"] && res.data["attachId"]) {
              res.data["id"] = res.data["attachId"];
            }
            this.fileList.push(res.data);
            this.update();
          }
        })
        .catch((err) => {
          console.log("err==>", err);
        });
    },
    //移除
    handleRemove(file) {
      let deleteIndex;
      this.fileList.forEach((item, index) => {
        if (item == file) {
          deleteIndex = index;
        }
      });
      if (deleteIndex !== undefined) {
        this.fileList.splice(deleteIndex, 1);
      }
      this.update();
    },
    //下载方法
    handleDownload(file) {
      console.log("file==>", file);
      downloadFile(file.link, file.originalName);
    },
  },
};
</script>
